import PageCard from "features/shared/components/card/PageCard";
import { groupBy } from "features/shared/helpers/Arrays";
import React from "react";
import { useTranslation } from "react-i18next";
import RequirementDescriptorDTO from "../dtos/RequirementDescriptorDTO";
import RequirementDescriptor from "./RequirementDescriptor";

interface Props {
  descriptors: RequirementDescriptorDTO[];
}

const RequirementDescriptorsCard = ({ descriptors }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // helpers
  const getDescriptorElement = (descriptor: RequirementDescriptorDTO, code: string) => {
    return (
      <div className="col-sm-6 col-lg-4 px-sm-3 pb-2" key={code}>
        <RequirementDescriptor descriptor={descriptor} />
      </div>
    );
  }

  // sub-renders
  const renderDescriptors = () => {
    let result: JSX.Element[] = [];
    let groupedDescriptors = groupBy(descriptors, "code");

    for (const [code, descriptorsInGroup] of Object.entries(groupedDescriptors)) {
      if (descriptorsInGroup.length == 1) {
        result.push(getDescriptorElement(descriptorsInGroup[0], code));
      } else if (descriptorsInGroup.length > 1) {
        let enumDesc:RequirementDescriptorDTO = {...descriptorsInGroup[0]};
        enumDesc.valueExtended = descriptorsInGroup.map(desc => desc.valueExtended).join(", ");
        result.push(getDescriptorElement(enumDesc, code));
      }
    }

    return result;
  };

  // render
  if (descriptors.length > 0) {
    return (
      <PageCard title={tLabels("requirementDescriptorsCard.expandingInformation")} bodyClassName="pb-1">
        <div className="row no-gutters">{renderDescriptors()}</div>
      </PageCard>
    );
  } else {
    return null;
  }
};

export default RequirementDescriptorsCard;
